import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {IDaymenu} from '../../model/daymenu';
import {IMenupart} from '../../model/menupart';
import {IMenupartOrder} from '../../model/menupart-order';
import {IOrder} from '../../model/order';
import {IToken} from '../../model/token';
import {IUser} from '../../model/user';
import {ConfigurationProvider} from '../configuration/configuration';
import {HttpServiceProvider} from '../http-service/http-service';
import {IUserDto} from '../../model/user-dto';
import {IShiftOrderStatistics} from '../../model/order-statistics';
import {Order} from "../../model/lib/interfaces/Order";
import {User} from "../../model/lib/interfaces/User";
import {CustomerAccount} from "../../model/lib/interfaces/CustomerAccount";

/*
  Generated class for the CookandeatApiProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class CookandeatApiProvider {
  constructor(private configurationService: ConfigurationProvider,
              private httpService: HttpServiceProvider) {
  }

  verifyOrderMenupartPresent(selector: (order: IOrder) => IMenupartOrder[], order: IOrder, menupart: IMenupart) {
    return selector(order).find(mpo => mpo.menupartId === menupart.id) !== undefined;
  }

  verifyDaymenus(daymenus: IDaymenu[]): IDaymenu[] {
    daymenus.forEach(daymenu => daymenu = this.verifyDaymenu(daymenu));
    return daymenus;
  }

  verifyDaymenu(daymenu: IDaymenu): IDaymenu {
    daymenu.shifts.forEach(shift => {
      let order = daymenu.orders.find(order => order.shift.id === shift.id);
      if (order === undefined) {
        order = <IOrder>{
          id: null,
          shift: shift,
          daymenuId: daymenu.id,
          consumed: false,
          canteen: <IMenupartOrder[]>[],
          takeaway: <IMenupartOrder[]>[],
          deliver: <IMenupartOrder[]>[]
        };
        daymenu.orders.push(order);
      }
      daymenu.menuparts.forEach(menupart => this.verifyMenupart(order, menupart));
    });
    return daymenu;
  }

  verifyMenupart(order: IOrder, menupart: IMenupart) {
    if (!this.verifyOrderMenupartPresent(o => o.canteen, order, menupart)) {
      order.canteen.push(<IMenupartOrder>{menupartId: menupart.id, count: 0});
    }
    if (!this.verifyOrderMenupartPresent(o => o.takeaway, order, menupart)) {
      order.takeaway.push(<IMenupartOrder>{menupartId: menupart.id, count: 0});
    }
    if (!this.verifyOrderMenupartPresent(o => o.deliver, order, menupart)) {
      order.deliver.push(<IMenupartOrder>{menupartId: menupart.id, count: 0});
    }
  }

  orderStatistics(date: Date): Observable<IShiftOrderStatistics[]> {
    return this.httpService
      .get(this.configurationService.apiUrl() + `checkin/orderStatistics?date=${date.toUTCString()}`)
      .map(data => {
        const os = <IShiftOrderStatistics[]>data.json();
        os.forEach(o => {
          o.canteen.orderStatistics.forEach(d => this.verifyDaymenus(d.daymenus));
          o.takeaway.orderStatistics.forEach(d => this.verifyDaymenus(d.daymenus));
          o.deliver.orderStatistics.forEach(d => this.verifyDaymenus(d.daymenus));
        });
        return os;
      })
  }

  orderStatistics2(date: Date): Observable<Order[]> {
    return this.httpService
      .get(this.configurationService.apiUrl() + `checkin/orderStatistics?date=${date.toUTCString()}`)
      .map(data => {
        const os = <Order[]>data.json();

        return os;
      })
  }

  ordering(username: string, orders: IOrder[]): Observable<IOrder[]> {
    return this.httpService
      .post(this.configurationService.apiUrl() + `checkin/ordering?username=${username}`, orders)
      .map(data => <IOrder[]>data.json());
  }

  userByCardId(cardId: string): Observable<IUserDto> {
    return this.httpService
      .get(this.configurationService.apiUrl() + `checkin/userByCardId?cardId=${cardId}`)
      .map(data => <IUserDto>data.json());
  }

  customerAccountById(id: number): Observable<CustomerAccount> {
    return this.httpService
      .get(this.configurationService.apiUrl() + `business/customer/account/user/${id}`)
      .map(data => <CustomerAccount>data.json());
  }

  customerAccountsByLastnameBegins(pattern: string): Observable<CustomerAccount[]> {
    return this.httpService
      .get(this.configurationService.apiUrl() + `business/customer/account/user/all?pattern=${pattern}`)
      .map(data => <CustomerAccount[]>data.json());
  }

  ordersByUsername(username: string): Observable<IDaymenu[]> {
    return this.httpService
      .get(this.configurationService.apiUrl() + `checkin/ordersByUsername?username=${username}`)
      .map(data => this.verifyDaymenus(<IDaymenu[]>data.json()));
  }

  consumeOrder(orderId: string): Observable<IOrder> {
    return this.httpService
      .get(this.configurationService.apiUrl() + `checkin/consumeOrder?orderId=${orderId}`)
      .map(data => <IOrder>data.json());
  }

  consumeOrderCancelation(orderId: string): Observable<IOrder> {
    return this.httpService
      .get(this.configurationService.apiUrl() + `checkin/consumeOrderCancelation?orderId=${orderId}`)
      .map(data => <IOrder>data.json());
  }

  currentUser(): Observable<User> {
    return this.httpService
      .get(this.configurationService.apiUrl() + "user/get")
      .map(data => <User>data.json());
  }

  updateUser(user: IUser): Observable<IUser> {
    return this.httpService
      .put(this.configurationService.apiUrl() + "management/canteen/user/update", user)
      .map(data => <IUser>data.json());
  }

  registerNfcToken(token: string) {
    return this.httpService
      .put(this.configurationService.apiUrl() + "user/registerNfcToken", token);
  }

  revokeNfcToken() {
    return this.httpService
      .put(this.configurationService.apiUrl() + "user/revokeNfcToken", {});
  }

  requestLongTermToken(): Observable<IToken> {
    return this.httpService
      .get(this.configurationService.apiUrl() + "user/longtermtoken")
      .map(data => <IToken>data.json());
  }
}



// WEBPACK FOOTER //
// ./src/providers/cookandeat-api/cookandeat-api.ts